import React, { useState, useEffect } from 'react';
import alanBtn from '@alan-ai/alan-sdk-web';

import wordsToNumbers from 'words-to-numbers';

import useStyles from './styles'
import NewsCards from './components/News-Cards/NewsCards'

const alanKey ='65696122693375ca35ec882459f3d0ee2e956eca572e1d8b807a3e2338fdd0dc/stage';

const App =() => {
  const [newsArticles, setNewsArticles] = useState([]);
  const [activeArticle, setActiveArticle] =useState(-1);
  const classes =useStyles();
  
  useEffect(() => {
    alanBtn({
      key: alanKey,
      onCommand: ({ command, articles, number }) => {
        if(command === 'newHeadlines') {
          setNewsArticles(articles);
          setActiveArticle(-1);
        }else if(command === 'highlight') {
          setActiveArticle((prevActiveArticle) => prevActiveArticle + 1 );
        }else if (command === 'open'){
          const parsedNumber = number.length > 2 ? wordsToNumbers(number, { fuzzy: true}) : number;
          const article = articles[parsedNumber-1];

          if(parsedNumber > 20) {
            alanBtn().playText('I dont know which article you are talking about')
          } else if(article) {
            window.open(article.url, '_blank');
            alanBtn().playText('opening...');
          } 
        }
      }
    })
  }, [])

  return(
    <div>
      <div className={classes.logoContainer}>
        <img  src="https://voicebot.ai/wp-content/uploads/2019/10/alan.jpg" className={classes.alanLogo} alt="alan logo"/>
      </div>
      <NewsCards articles={newsArticles} activeArticle={activeArticle}/>
    </div>
    );
}



export default App;
